var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.game)?_c('UseCodePanel',{attrs:{"id-game":_vm.game.id}}):_c('NotFoundPanel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }